import React from 'react';

const getModuleImage = (iconName) => {
    if (!iconName) return '/img/application/complet.png';
    // Remove .png extension if present
    const iconBase = iconName.replace('.png', '');
    return `/img/application/${iconBase}.png`;
};

const formatTime = (seconds) => {
    if (!seconds || seconds <= 0) return null;
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    if (h > 0) return `${h}h${m > 0 ? String(m).padStart(2, '0') : ''}`;
    return `${m}min`;
};

const ModuleButton = ({
    module,
    isSelected,
    onClick,
    language = 'fr'
}) => {
    const title = language === 'fr' ? module.libelle_fr : module.libelle_en;
    const progress = module.progress || 0;
    const time = formatTime(module.totalTime);

    return (
        <button
            onClick={() => onClick(module.idModule)}
            className={`relative group flex flex-col items-center justify-center gap-3 md:gap-4 p-4 md:p-6 rounded-2xl md:rounded-3xl transition-all duration-300 border w-full h-full
                ${isSelected
                    ? 'bg-white dark:bg-[#121212] border-blue-400 dark:border-blue-400/60 shadow-[0_0_15px_rgba(59,130,246,0.3)] dark:shadow-[0_0_20px_rgba(59,130,246,0.25)] ring-1 ring-blue-300/50 dark:ring-blue-400/30'
                    : 'bg-white dark:bg-[#121212] border-gray-200 dark:border-white/5 hover:border-gray-300 dark:hover:border-white/10 hover:bg-gray-50 dark:hover:bg-[#1a1a1a]'
                }`}
        >
            {/* Icon Container */}
            <div className="w-10 h-10 flex items-center justify-center opacity-80 group-hover:opacity-100 transition-opacity">
                <img
                    src={getModuleImage(module.icon)}
                    alt={title}
                    className={`w-full h-full object-contain transition-all
                        ${isSelected
                            ? 'brightness-110'
                            : 'brightness-50 light:brightness-40 grayscale-[0.5] group-hover:brightness-90 light:group-hover:brightness-60 group-hover:grayscale-0'
                        }`}
                    onError={(e) => {
                        e.target.style.display = 'none';
                    }}
                />
            </div>

            {/* Label */}
            <span className={`text-[10px] font-black text-center uppercase tracking-widest transition-colors leading-tight whitespace-nowrap
                ${isSelected
                    ? 'text-blue-600 dark:text-blue-400'
                    : 'text-gray-600 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-gray-200'
                }`}
            >
                {title}
            </span>

            {/* Progress bar + time (desktop only) */}
            <div className="hidden md:flex flex-col items-center gap-1 w-full px-1">
                <div className="w-full h-1 rounded-full overflow-hidden bg-gray-200 dark:bg-white/10">
                    <div
                        className={`h-full rounded-full transition-all duration-500 ${
                            progress === 100
                                    ? 'bg-green-500'
                                    : progress >= 50
                                        ? 'bg-yellow-500'
                                        : progress > 0
                                            ? 'bg-blue-500'
                                            : 'bg-transparent'
                        }`}
                        style={{ width: `${progress}%` }}
                    />
                </div>
                <div className="flex items-center gap-1">
                    <span className={`text-[8px] font-bold ${isSelected ? 'text-blue-500 dark:text-blue-400' : 'text-gray-400 dark:text-gray-500'}`}>
                        {progress}%
                    </span>
                    {time && (
                        <>
                            <span className="text-[8px] text-gray-300 dark:text-gray-600">·</span>
                            <span className={`text-[8px] font-medium ${isSelected ? 'text-blue-500 dark:text-blue-400' : 'text-gray-400 dark:text-gray-500'}`}>
                                {time}
                            </span>
                        </>
                    )}
                </div>
            </div>
        </button>
    );
};

export default ModuleButton;
